import { getScoreIconColor } from '@/src/utils/scoreUtils'
import { VpIcon, VpIconSize } from '@vtmn-play/react'
import { ComponentPropsWithoutRef } from 'react'
import { twMerge } from 'tailwind-merge'

type ScoreSize = 'sm' | 'md' | 'lg' | 'xl'

interface FamilyCardScoreProps extends ComponentPropsWithoutRef<'div'> {
  score?: number | null
  size?: ScoreSize
  scoreColored?: boolean
  isOnBrand?: boolean
}

const sizeClasses: Record<ScoreSize, string> = {
  sm: 'text-xs gap-1',
  md: 'text-sm gap-1.5',
  lg: 'text-base gap-2',
  xl: 'text-lg gap-2',
}

const iconSizes: Record<ScoreSize, VpIconSize> = {
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
}

const CardScore = ({
  score,
  size = 'lg',
  scoreColored = false,
  isOnBrand = false,
  className,
  ...props
}: FamilyCardScoreProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center font-medium',
        sizeClasses[size],
        className,
        scoreColored && getScoreIconColor(score, isOnBrand)
      )}
      {...props}
      data-testid="family-card-score"
    >
      <VpIcon
        data-testid="score-shield-icon"
        className={getScoreIconColor(score, isOnBrand)}
        size={iconSizes[size]} // On ajuste aussi l'icône proportionnellement
        name="shield-check"
      />
      <span>{score ?? '--'}%</span>
    </div>
  )
}

export default CardScore
